/**
 * @generated SignedSource<<173aa76cfd963807bcf8bb5c89f692e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionPageUpsertDialog_promotion$data = {
  readonly id: string;
  readonly page: {
    readonly bannerBackgroundColor: string;
    readonly bannerImage: {
      readonly key: string;
      readonly objectUrl: string;
      readonly size: number;
    } | null;
    readonly bannerSubText: string;
    readonly bannerSubTextColor: string;
    readonly bannerTitle: string;
    readonly bannerTitleColor: string;
    readonly detailBackgroundColor: string;
    readonly detailButtonLink: string;
    readonly detailButtonText: string;
    readonly detailImages: ReadonlyArray<{
      readonly deeplink: string | null;
      readonly image: {
        readonly key: string;
        readonly objectUrl: string;
        readonly size: number;
      };
    }> | null;
    readonly miniBannerSubText: string;
    readonly miniBannerTitle: string;
  } | null;
  readonly " $fragmentType": "PromotionPageUpsertDialog_promotion";
};
export type PromotionPageUpsertDialog_promotion$key = {
  readonly " $data"?: PromotionPageUpsertDialog_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionPageUpsertDialog_promotion">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionPageUpsertDialog_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionPage",
      "kind": "LinkedField",
      "name": "page",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerBackgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "bannerImage",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerSubText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerSubTextColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerTitleColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailBackgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailButtonLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailButtonText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailImageDeeplink",
          "kind": "LinkedField",
          "name": "detailImages",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deeplink",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "miniBannerSubText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "miniBannerTitle",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};
})();

(node as any).hash = "fd67e6c50f8e02762bc438c8544e61d6";

export default node;
